module.exports = __webpack_public_path__ + "static/api-thumb-c4a3866cefa575e2cfbda22b994ddd61.png";